import { Web3WagmiConnectors } from '@pkg/providers/Web3Provider/types';
import { type WalletConnectingData } from '@pkg/types';

import { useConnectAnyWallet } from './useConnectAnyWallet';

export function useConnectMetaMask(onConnect?: (connection: WalletConnectingData) => void) {
    return useConnectAnyWallet({
        walletConnector: Web3WagmiConnectors.Metamask,
        onConnect: () => onConnect?.({ type: 'metamask', step: 'success' }),
        onError: () => onConnect?.({ type: 'metamask', step: 'error' }),
    });
}
